import styled, {ThemeProps} from 'styled-components';

import {Theme} from '@stencil/build-theme/src/types';
import {Column, Row, ColumnStyles} from '../../../common/Layouts/Layouts';

import Image from '@stencil/image';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';

export const WrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.xlarge};
  border-radius: ${props.theme.misc.borderRadius.large};
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  margin-bottom: 15px;
`,
);

export const UserAvatarWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding-right: ${props.theme.spacing.small};
  width: 5%;
`,
);

export const UserReviewOuterWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-left: ${props.theme.spacing.small};
  width: 95%;
`,
);

export const UserReviewWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.xlarge};
  padding-bottom: ${props.theme.spacing.xlarge};
`,
);

export const UserReviewTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(16)};
  text-decoration: none!important;

  .active {
    font-weight: 600;
  }
`,
);

export const UserDetailsAndRatingWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  justify-content: space-between;
  align-items: center;
  height:50px;
`,
);

export const UserReviewImageListWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  position: relative;
  padding-top: ${props.theme.spacing.xlarge};
  padding-bottom: ${props.theme.spacing.xlarge};
`,
);

export const RowWithMarginR10 = styled(Row)(
  (props: ThemeProps<Theme>) => `
  position: relative;
  margin-right: ${props.theme.spacing.base};
  margin-top:${props.isUpsellFlow ? '5px' : ''};
`,
);

export const LikeSectionWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  padding-bottom: ${props.theme.spacing.base};
  align-items: baseline;
`,
);

export const StyledImage = styled(Image)(
  props => `
  display: flex;
  // height: 100%;
  cursor: pointer;
  height: 11.4rem;
  width: 11.4rem;
  // width: 100%;
  object-fit: cover;
  height: ${props.height}rem;
  width: ${props.width}rem;
  border-radius: ${props.theme.misc.borderRadius.large};
`,
);

export const ViewAllWrapDiv = styled.div(
  props => `
  display: flex;
  position: absolute;
  bottom: ${props.theme.spacing.custom(6)};
  left: 0;
  top: 0;
  width: 11.4rem;
  height: 11.4rem;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: ${props.theme.colors.shadow.dark};
  cursor: pointer;
  border-radius: ${props.theme.misc.borderRadius.large};
`,
);

export const ViewAllText = styled.span(
  props => `
  font-size:${props.theme.font.custom(16)};
  color: ${props.theme.colors.goWhite.base};
`,
);

export const HotelierResponseWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  width: 90%;
  padding-top: ${props.theme.spacing.base};
`,
);

export const HotelierResponseContentStyle = styled.div(
  (props: ThemeProps<Theme>) => `
${ColumnStyles}
padding: ${props.theme.spacing.large} ${props.theme.spacing.base} ${props.theme.spacing.large} ${props.theme.spacing.base};
width: 100%;
border-radius: ${props.theme.misc.borderRadius.large};
background-color: ${props.theme.colors.goBrandBlue.light};
`,
);

export const HotelierNameTextStyle = styled.p(
  (props: ThemeProps<Theme>) => `
font-size: ${props.theme.font.custom(14)};
color: ${props.theme.colors.downriver.medium};
`,
);

export const HotelierResponseTextStyle = styled.p(
  (props: ThemeProps<Theme>) => `
font-size: ${props.theme.font.custom(14)};
color: ${props.theme.colors.downriver.dark};
padding-top: ${props.theme.spacing.small};
white-space: pre-line;
`,
);

export const HelpfulTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `

color: ${props.theme.colors.goBrandBlue.base};
`,
);

export const LikeTextWrapper = styled.span(
  (props: ThemeProps<Theme>) => `

color: ${props.theme.colors.goBrandBlue.base};
padding-left: ${props.theme.spacing.base};
cursor: pointer;
&.active{
  font-weight: 600;
}
`,
);

export const LikeTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `

color: ${props.theme.colors.goBrandBlue.base};
padding-left: ${props.theme.spacing.custom(4)};
cursor: pointer;
&.active{
  font-weight: 600;
}
`,
);

export const RatingTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
font-weight: 600;
font-size: ${props.theme.font.custom(16)};
color: white;
`,
);

export const UserNameStyle = styled.span(
  (props: ThemeProps<Theme>) => `
font-weight: 600;
font-size: ${props.theme.font.custom(16)};
text-transform: capitalize;
`,
);

export const StayedOnStyle = styled.span(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.downriver.dark};
font-size: ${props.theme.font.custom(14)};
padding-left: ${props?.noPadding ? 0 : props.theme.spacing.small};
`,
);

export const AskedByStyle = styled.p(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.downriver.dark};
font-size: ${props.theme.font.custom(14)};
padding-top: ${props.theme.spacing.custom(7)};
text-transform: capitalize;
`,
);

export const InfoIconWrapper = styled.span(
  (props: ThemeProps<Theme>) => `
  position: relative;
  vertical-align: sub;
  &:hover > ${HiddenTooltipWrapperDiv} {
            visibility: visible;
          }
`,
);

export const VerifiedText = styled.p(
  (props: ThemeProps<Theme>) => `
  font-size: 14px;
  color: ${props.theme.colors.downriver.base};
  padding-bottom:10px;

`,
);

export const VerifiedIcon = styled.img(
  (props: ThemeProps<Theme>) => `
  height: 12px;
`,
);

export const HiddenTooltipWrapperDiv = styled.div(
  props => `
    width: 20rem;
    max-width: 20rem;
    z-index: ${props.theme.misc.zIndex.base};
    visibility: hidden;
    transition: opacity 0.8s;
    padding: 1.2rem 0.8rem;
    margin: ${props.theme.spacing.base} 0;
    position:absolute;
    right: -15.5rem;
    background-color: ${props.theme.colors.goWhite.base};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    filter: drop-shadow(0px 1px 7px rgba(0, 0, 0, 0.20));
    border-radius: 0.8rem;
    cursor: default;
  `,
);

const TipUI = styled.div(
  props => `
    position: absolute;
    margin-left: -${props.theme.spacing.base};
    width: 2.4rem;
    height: 1.2rem;
    overflow: hidden;
    &:: after {
      content: '';
      position: absolute;
      width: 1.3rem;
      height: 1.2rem;
      left: 50%;
    }
  `,
);

export const TipPositioning = styled(TipUI)(
  props => `
  left: 18%;
  top: -1.1rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: ${props.theme.colors.goWhite.base};
    box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)}
      ${props.theme.colors.shadow.base};
  }
  `,
);

export const RatingWrapperDiv = styled(Column)(props => {
  return `
    display: inline-block;
    padding: ${props.theme.spacing.small};
    border-radius: ${props.theme.misc.borderRadius.base};
    background-color: ${getRatingsColor(props.totalRating)};
  `;
});
